import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import { searchOrCreateBusiness } from 'lib/api/business';
import CustomButton from 'lib/designSystem/Button';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import { showAlert, validaRut } from 'lib/functions/utils';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

interface NewBusinessProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  setUp: (businessIdentifier?: string) => void;
}

const NewBusiness = (props: NewBusinessProps) => {
  const { open, setOpen, setUp } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [businessIdentifier, setBusinessIdentifier] = useState('');
  const [businessName, setBusinessName] = useState('');

  const handleSubmit = async () => {
    if (!businessIdentifier) {
      return showAlert(dispatch, 'error', 'El rut es requerido');
    }
    if (!validaRut(businessIdentifier)) {
      return showAlert(dispatch, 'error', 'El rut no es válido');
    }
    setLoading(true);
    try {
      await searchOrCreateBusiness(dispatch, businessIdentifier, {
        name: businessName,
      });
      showAlert(dispatch, 'success', 'Empresa creada correctamente');
      setUp(businessIdentifier);
      setLoading(false);
      setOpen(false);
    } catch (error) {
      console.error(error);
      showAlert(dispatch, 'error', 'Ha ocurrido un error');
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogTitle>Crear nueva empresa</DialogTitle>
      <DialogContent>
        {loading ? (
          <CenteredCircularProgress type="dialog" />
        ) : (
          <Box display="flex" flexDirection="column" gap={2} mt={1}>
            <TextField
              label="RUT (sin puntos, con guión)"
              fullWidth
              value={businessIdentifier}
              onChange={(e) =>
                setBusinessIdentifier(e.target.value.toUpperCase())
              }
            />
            <TextField
              label="Razón Social"
              fullWidth
              value={businessName}
              onChange={(e) => setBusinessName(e.target.value)}
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <CustomButton
          color="secondary"
          onClick={() => setOpen(false)}
          disabled={loading}
        >
          Cancelar
        </CustomButton>
        <CustomButton
          color="primary"
          onClick={() => handleSubmit()}
          disabled={loading}
        >
          Crear
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default NewBusiness;
